<template>
  <div class="step_two">
    <div class="two_info">
      <div class="step_title">物流信息</div>
      <div class="two_info_bottom">
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>是否到货</div>
          <div class="type_content shifdh">
            <el-radio
              v-model="$store.state.orderData.isArrival"
              label="true"
              border
              >已到货</el-radio
            >
            <el-radio
              v-model="$store.state.orderData.isArrival"
              label="false"
              border
              >未到货</el-radio
            >
            <div
              class="thwd"
              v-if="$store.state.orderData.isArrival == 'false'"
            >
              若“未到货”，订单提交后，可在
              <span style="font-weight: bold">订单详情</span>修改到货状态
            </div>
            <div
              class="not_goods"
              v-if="!$store.state.orderData.takeDeliveryFee"
            >
              (不需师傅提货，已到货表示商品已到客户家中）
            </div>
          </div>
        </div>

        <div v-if="$store.state.orderData.takeDeliveryFee">
          <div class="two_label">
            <div class="type_name">
              <span
                class="xing"
                v-if="
                  $store.state.orderData.takeDeliveryFee &&
                  $store.state.orderData.isArrival == 'true'
                "
                >*</span
              >物流单号
            </div>
            <div class="type_content">
              <el-input
                v-model="$store.state.orderData.logisticsNo"
                placeholder="请输入"
                maxlength="255"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">
              <span
                class="xing"
                v-if="
                  $store.state.orderData.takeDeliveryFee &&
                  $store.state.orderData.isArrival == 'true'
                "
                >*</span
              >物流电话
            </div>
            <div class="type_content">
              <el-input
                v-model.trim="$store.state.orderData.logisticsPhone"
                placeholder="请输入"
                maxlength="12"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">物流公司</div>
            <div class="type_content">
              <!-- <el-input
                v-model="$store.state.orderData.logisticsCompany"
                placeholder="请输入"
              ></el-input> -->
              <el-select
                v-model="$store.state.orderData.logisticsCompany"
                filterable
                remote
                reserve-keyword
                placeholder="请输入物流公司名称"
                :remote-method="getLogisticsCompany"
                :loading="loading"
                @change="getLogisticsCompany"
              >
                <el-option
                  v-for="item in logisticsCompany"
                  :key="item.value"
                  :label="item.companyName"
                  :value="item.companyCode"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">提货码</div>
            <div class="type_content">
              <el-input
                v-model="$store.state.orderData.pickupCode"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="two_label">
            <div class="type_name">提货地址</div>
            <div class="type_content">
              <el-input
                v-model="$store.state.orderData.pickupAddress"
                placeholder="请输入"
                @input="getPickUpLnglat"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="two_info">
      <div class="step_title">其他信息</div>
      <div class="two_info_bottom">
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>是否核销</div>
          <div class="type_content">
            <el-radio
              v-model="$store.state.orderData.verifType"
              label="NOT"
              border
              >不需要</el-radio
            >
            <el-radio
              v-model="$store.state.orderData.verifType"
              label="MIAO"
              border
              >喵师傅</el-radio
            >
            <el-radio
              v-model="$store.state.orderData.verifType"
              label="WANG"
              border
              >汪师傅</el-radio
            >
          </div>
        </div>

        <div>
          <div
            class="two_label"
            v-show="$store.state.orderData.verifType != 'NOT'"
          >
            <div class="type_name">核销单号</div>
            <div class="type_content">
              <el-input
                v-model="$store.state.orderData.verifOrderNo"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <div class="two_label two-date">
            <div class="type_name qiwangdate">期望服务时间</div>
            <div class="type_content">
              <el-date-picker
                class="dan_date"
                v-model="$store.state.orderData.expectedTime"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
              <div class="tishi">（期望师傅在该时间内完成服务）</div>
            </div>
          </div>

          <div class="two_label">
            <div class="type_name remarks">备注</div>
            <div class="type_content">
              <el-input
                type="textarea"
                placeholder="请备注特殊要求"
                v-model="$store.state.orderData.remark"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="two_info">
      <div class="step_title">您的联系方式</div>
      <div class="two_info_bottom">
        <div class="two_label">
          <div class="type_name"><span class="xing">*</span>您的姓名</div>
          <div class="type_content">
            <el-input
              v-model="$store.state.orderData.userName"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="two_label">
          <div class="type_name phone_num">
            <span class="xing">*</span>手机号码
          </div>
          <div class="type_content">
            <el-input
              v-model="$store.state.orderData.userPhone"
              placeholder="请输入"
              maxlength="11"
            ></el-input>
            <div class="tishi">
              （任务进度会短信通知此号码，师傅服务中遇到异常问题也通过此号码联系您）
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="step_two_price">
      <div>
        费用核对：
        <span>¥{{ $store.state.priceList.totalFee }}</span>
      </div>
    </div>
    <div class="step_two_btns">
      <el-button class="last_step btn" @click="goBack()">返回上一步</el-button>
      <el-button
        class="next_step btn"
        :loading="disabledBtn"
        @click="openPrice()"
        >立即支付</el-button
      >
    </div>
  </div>
</template>

<script>
import Bus from "./../../utils/bus.js";
import $ from "jquery";

export default {
  data() {
    return {
      arrival: "1",
      writeOff: "3",
      writeOffOreder: "",
      serviceDate: "",
      disabledBtn: false,
      loading: false,
      logisticsCompany: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
        ],
      },
    };
  },
  created() {
    var data = {
      url: "stepTwo",
      step: 2,
    };
    Bus.$emit("val", data);
  },
  activated() {
    var _this = this;
    _this.$store.state.defaultUrl = "";
    if (_this.$store.state.orderData.userName == "") {
      // 用户信息
      this.$fetch(`/user/api/customer`).then((res) => {
        if (res.code == 0) {
          _this.$store.state.orderData.userName = res.data.nickname;
          _this.$store.state.orderData.userPhone = res.data.username;
        } else {
          // this.$message(res.message);
        }
      });
      this.getLogisticsCompany();
    }
  },
  // mounted() {
  //   var _this = this;
  //   _this.$store.state.defaultUrl = "";
  //   if (_this.$store.state.orderData.userName == "") {
  //     // 用户信息
  //     this.$fetch(`/user/api/customer`).then(res => {
  //       if (res.code == 0) {
  //         _this.$store.state.orderData.userName = res.data.nickname;
  //         _this.$store.state.orderData.userPhone = res.data.username;
  //       } else {
  //         // this.$message(res.message);
  //       }
  //     });
  //   } else {
  //   }
  // },

  methods: {
    // 获取物流公司
    getLogisticsCompany(e) {
      console.log(e);
      let params = {
        name: e,
        pageNo: 1,
        pageSize: 20,
      };
      this.$fetch("/common/api/wuliu/wuliu_company_search", params).then(
        (res) => {
          if (res.code == 0) {
            this.logisticsCompany = res.data.records;
          }
        }
      );
    },
    goBack() {
      this.$router.push({ path: "/placeorder/stepone" });
    },
    // 查询提货位置
    getPickUpLnglat() {
      let _this = this;
      let params = {
        key: process.env.VUE_APP_MAP_KEY,
        address: this.$store.state.orderData.pickupAddress,
      };

      $.ajax({
        type: "get",
        dataType: "jsonp",
        cache: false,
        data: params,
        url: "https://restapi.amap.com/v3/geocode/geo",

        success: function (json) {
          console.log(json);
          if (json.info == "OK") {
            _this.$store.state.orderData.pickUpLng =
              json.geocodes[0].location.split(",")[0];
            _this.$store.state.orderData.pickUpLat =
              json.geocodes[0].location.split(",")[1];
          }
        },
      });
    },
    openPrice() {
      this.$message.closeAll();
      var _this = this;
      // this.getPickUpLnglat()
      if (Cookies.get("token") == undefined) {
        this.$store.state.defaultUrl = this.$route.path;

        this.$router.push({ path: "/login" });
      } else {
        var myreg = /^1[123456789]\d{9}$/;
        var orderData = this.$store.state.orderData;
        if (orderData.takeDeliveryFee) {
          if (orderData.logisticsNo == "" && orderData.isArrival == "true") {
            this.$message.error("请输入物流单号");
            return;
          }
          if (
            parseFloat(orderData.logisticsPhone).toString() == "NaN" &&
            orderData.isArrival == "true"
          ) {
            this.$message.error("请输入合法的物流电话号码");
            return;
          }
        }
        if (orderData.userName == "") {
          this.$message.error("请输入您的姓名");
          return;
        }
        if (!myreg.test(orderData.userPhone)) {
          this.$message.error("请输入您的合法电话号码");
          return;
        }
        var orderItems = [];
        for (let i of orderData.orderItems) {
          orderItems.push({
            name: i.name,
            count: i.count,
            goodsTypeId: i.goodsTypeId,
            description: i.description,
            imgUrl: i.imgUrl,
            installVideoUrl: i.installVideoUrl,
            packingMethod: i.packingMethod,
          });
        }

        this.disabledBtn = true;
        // this.disabledBtn=false;
        this.$post(`/order/api/order`, {
          goodsTypeId: orderData.goodsTypeId, //一级商品类目id
          serviceType: orderData.serviceType, //服务类型id
          customerName: orderData.customerName, //客户姓名
          customerPhone: orderData.customerPhone, //客户电话
          isLift: orderData.isLift, //是否有电梯
          floorsNumber: orderData.floorsNumber, //电梯层数
          areaCode: orderData.areaCode[orderData.areaCode.length - 1], //地区code
          address: orderData.address, //联系地址
          orderItems: orderItems, //商品列表
          totalVolume: orderData.totalVolume, // 订单总体积
          packingCount: orderData.packingCount, //包装数量
          isArrival: orderData.isArrival, //是否到货
          logisticsNo: orderData.logisticsNo, //物流单号
          logisticsPhone: orderData.logisticsPhone, //物流电话
          logisticsCompany: orderData.logisticsCompany, //物流公司
          pickupCode: orderData.pickupCode, //提货码
          pickupAddress: orderData.pickupAddress, //提货地址
          pickUpLng: orderData.pickUpLng,
          pickUpLat: orderData.pickUpLat,
          verifType: orderData.verifType, //是否核销
          verifOrderNo: orderData.verifOrderNo, //核销订单号
          expectedTime: orderData.expectedTime, //期望服务时间
          remark: orderData.remark, //备注
          userName: orderData.userName, //您的姓名
          userPhone: orderData.userPhone, //您的电话
        }).then((res) => {
          if (res.code == 0) {
            _this.disabledBtn = false;
            orderData.orderNum = res.data.orderId;
            _this.$store.state.orderData = {
              goodsTypeId: "", //一级商品类目id
              takeDeliveryFee: "", //是否含送货费
              serviceType: "", //服务类型id
              customerName: "", //客户姓名
              customerPhone: "", //客户电话
              isLift: "true", //是否有电梯
              floorsNumber: "", //电梯层数
              areaCode: [], //地区code
              address: "", //联系地址
              orderItems: [
                //商品列表
                {
                  fileList: [], //图片list
                  videoList: [], //视频list
                  imgUrl: "", //图片地址
                  installVideoUrl: "", //视频地址
                  goodsTypeIdList: [], //商品类别id数组
                  goodsTypeId: "", //商品类别id
                  name: "", //商品名称
                  count: "1", //商品数量
                  packingMethod: "", //包装方式
                  description: "", // 商品描述
                },
              ],
              totalVolume: "0", // 订单总体积
              packingCount: "1", //包装数量
              isArrival: "true", //是否到货
              logisticsNo: "", //物流单号
              logisticsPhone: "", //物流电话
              logisticsCompany: "", //物流公司
              pickupCode: "", //提货码
              pickupAddress: "", //提货地址
              pickUpLng: "",
              pickUpLat: "",
              verifType: "NOT", //是否核销
              verifOrderNo: "", //核销订单号
              expectedTime: "", //期望服务时间
              remark: "", //备注
              userName: "", //您的姓名
              userPhone: "", //您的电话
            };
            _this.$router.replace({
              path: "/placeorder/orderPayment",
              query: { orderid: res.data.orderId },
            });
          } else {
            this.$message(res.message);
            this.disabledBtn = false;
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.two_label {
  .el-radio {
    margin-left: 0 !important;
  }
}
.el-date-editor.el-input {
  width: 392px !important;
}
.el-date-picker.has-sidebar {
  width: 322px !important;
  height: 368px !important;
}
.el-date-picker {
  .el-picker-panel__sidebar {
    top: 329px !important;
    height: 28px !important;
    width: 100% !important;
    border-top: 1px solid #e4e4e4;
    border-right: none !important;
    left: 0 !important;
    overflow: hidden !important;
  }
  .el-picker-panel__shortcut {
    padding-left: 0 !important;
    text-align: center !important;
  }
  .el-picker-panel__sidebar + .el-picker-panel__body {
    margin-left: 0 !important;
  }
}
.el-date-table td.current:not(.disabled) span {
  background-color: #3455d3 !important;
  border-radius: 2px !important;
  color: #fff !important;
}
.el-date-table td.today span {
  color: #3455d3 !important;
}
.el-date-table td.available:hover,
.el-picker-panel__icon-btn:hover,
.el-date-picker__header-label:hover,
.el-picker-panel__shortcut:hover {
  color: #3455d3 !important;
}
.el-icon-date {
  font-size: 17px;
}
.el-button:active {
  border-color: #3455d3;
}
</style>
<style lang="scss" scoped>
.step_title {
  height: 50px;
  padding: 0 63px;
  line-height: 50px;
  color: #2f3133;
  font-size: 18px;
  background: #f9fafa;
  border-bottom: 1px solid #dfe4eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xing {
  color: #f75658;
  font-size: 14px;
  margin-right: 4px;
}
.two_info {
  margin-top: 15px;
  .two_info_bottom {
    background: #fff;
    padding: 30px 106px;
    .two_label {
      text-align: right;
      color: #5e6066;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .type_name {
        width: 105px;
      }
      .qiwangdate {
        margin-top: -20px;
      }
      .remarks {
        margin-top: -37px;
      }
      .phone_num {
        margin-top: -25px;
      }
      .type_content {
        margin-left: 14px;
        text-align: left;
        .tishi {
          color: #909399;
          font-size: 12px;
          text-align: left;
          margin-top: 5px;
        }
        .thwd {
          font-size: 12px;
          color: #5e6066;
          margin-left: 10px;
        }
      }
      .shifdh {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .not_goods {
          color: #ffad16;
          width: 100%;
          height: 12px;
          font-size: 12px;
          line-height: 1;
          margin-top: 10px;
        }
      }
    }
    .two_label:last-child {
      margin-bottom: 0;
    }
  }
}
.step_two_price {
  height: 132px;
  padding: 50px 74px;
  background: #fff;
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  & > div {
    color: #2f3133;
    font-size: 14px;
    display: flex;
    align-items: center;
    span {
      font-size: 32px;
      color: #f75658;
      margin-left: 12px;
    }
  }
}
.step_two_btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  .btn {
    width: 190px;
    height: 46px;
    border-radius: 2px;
    font-size: 20px;
  }
  .last_step {
    border: 1px solid #909399;
    color: #5e6066;
    background: rgba(52, 85, 211, 0);
  }
  .last_step:hover {
    border-color: #3455d3;
    color: #3455d3;
  }
  .next_step {
    color: #fff;
    background: rgba(52, 85, 211, 1);
  }
}
</style>
<style lang="scss" scoped>
.step_two {
  .el-input--prefix .el-input__inner {
    padding-left: 30px !important;
  }
}
</style>
<style lang="scss" scoped>
.step_two {
  .two-date {
    &/deep/.el-input__inner {
      padding-left: 30px !important;
    }
  }
}
</style>
